import Request from '../modules/XMLHttpRequest';

// Matomo queue: if matomo.js hasn't been injected (consent declined, blocker, or
// hostname not configured in GTM/CookieInformation), pushes become no-ops on a
// detached array instead of throwing — which would otherwise break add-to-cart.
window._paq = window._paq || [];

class Basket {

    constructor() {
        this.flexnav = document.querySelector('[data-js="flexnav"]');
        this.basketHeaderAmount = document.querySelector('[data-js="header-basket-amount"]'),
            this.basket = document.querySelector('[data-js="basket"]');
        this.basketAppend = document.querySelector('[data-js="basket-popup-append"]');
        this.productPage = document.querySelector('[data-js="product-page"]');
        this.addToBasketBtn = document.querySelectorAll('[data-js="add-to-basket"]');
        this.language = document.getElementsByTagName('html')[0].getAttribute('commerce-lang');

        //Basket
        if (this.basket) {
            this.changeQuantityInteraction();
            this.applyCouponCodeInteraction();
        }

        //Basket popup
        if (this.basketAppend) {
            this.addToBasketInteraction();
            this.toggleBasketPopupOnHover();
        }
    }

    /**
     * PRODUCT QUANTITY
     */

    //Interact with remove product btn
    changeQuantityInteraction() {
        let btnChange = document.querySelectorAll('[data-btn="remove"], [data-btn="subtract"], [data-btn="add"]');
        [...btnChange].forEach(btnChange => btnChange.addEventListener('click', (e) => this.changeQuantityCall(e)));
    }

    //Remove product btn ajax call
    changeQuantityCall(e) {
        e.preventDefault();

        let basket = document.querySelector('[data-js="basket"]'),
            $this = this,
            request = new Request(),
            item = $(e.target).parents('[data-js="basket-item"]')[0],
            code = item.getAttribute('data-code'),
            quantity = item.querySelector('[data-quantity]').getAttribute('data-quantity'),
            btnAction = e.target.getAttribute('data-btn');

        switch (btnAction) {
            case 'add':
                quantity++;
                _paq.push(['addEcommerceItem', code, null, null, null, 1]);
                break;
            case 'subtract':
                quantity--;
                _paq.push(['removeEcommerceItem', code]);
                if (quantity > 0) {
                    _paq.push(['addEcommerceItem', code, null, null, null, 1]);
                }
                break;
            case 'remove':
                quantity = 0;
                _paq.push(['removeEcommerceItem', code]);

                break;
        }
        

        request.get(`/api/cartapi/ChangeQuantity/${code}/${quantity}/${this.language}`).then(function (response) {
            let data = JSON.parse(response);

            basket.outerHTML = data.Html;
            $this.basketHeaderAmount.innerHTML = data.ItemsInCart;
            $this.basketAppend.innerHTML = data.Html;

            //Matomo tracking
            _paq.push(['trackEcommerceCartUpdate', data.CartTotal]);
            
            //Restart interaction
            $this.changeQuantityInteraction();
        }, function (error) {
            console.error("Failed!", error);
        });
    }

    /**
     * Add to basket from product/course pages
     */

    //Add product to basket interaction
    addToBasketInteraction() {
        [...this.addToBasketBtn].forEach(addToBasketBtn => addToBasketBtn.addEventListener('click', (e) => this.addToBasket(e)));
    }

    //Add product to basket call
    addToBasket(e) {
        e.preventDefault();

        let $this = this,
            request = new Request(),
            licenseSelect = document.getElementById('license-length'),
            productId = e.target.getAttribute('data-id');

        //If course the course id is on the btn, if a product the id is on the dropdown
        if (productId === null) {
            //Exit if button is disabled
            if (e.target.classList.contains('disabled')) {
                return false;
            }

            //Exit if no license is selected
            if (!licenseSelect) {
                return false;
            }

            productId = licenseSelect.options[licenseSelect.selectedIndex].value;

            //Exit if no product id is chosen
            if (productId === ' ' || productId === '') {
                return false;
            }
        }

        e.target.className += ' disabled';

        //Matomo tracking
        _paq.push(['addEcommerceItem', productId, null,null,null,1]);

        request.get(`/api/cartapi/addtocart/${productId}/1/${this.language}`).then(function (response) {
            $this.basketAppend.innerHTML = JSON.parse(response).Html;
            $this.basketHeaderAmount.innerHTML = JSON.parse(response).ItemsInCart;
            $this.basketHeaderAmount.className += ' show';

            let basketPopup = document.querySelector('[data-js="basket-popup"]');

            //Placement of basket on init
            if (window.scrollY < $this.flexnav.clientHeight) {
                basketPopup.style.top = '19px';
            }

            //Show basket and add scroll event
            setTimeout(() => basketPopup.className += ' show', 50);
            //window.addEventListener('scroll', $this.setScroll);
            $(window).on('scroll.basketpopup', function () {
                if (window.pageYOffset < $this.flexnav.clientHeight) {
                    basketPopup.style.top = '19px';
                }
            });

            //After a set time remove popup, make btn clickable again and remove scroll event
            setTimeout(function () {
                $(basketPopup).removeClass('show');
                $(window).off('scroll.basketpopup');
                setTimeout(function () {
                    $(e.target).removeClass('disabled')
                }, 250);
            }, 3000);
        }, function (error) {
            console.error("Failed!", error);
            $(e.target).removeClass('disabled')
        });
    }

    /**
     * Show/hide popup basket
     */

    //Toggle basket on basket icon interaction
    toggleBasketPopupOnHover() {
        let headerBasket = document.querySelector('[data-js="header-basket"]');

        if (headerBasket) {
            headerBasket.addEventListener('mouseover', (e) => this.toggleBasketPopupToggle(e, true));
            headerBasket.addEventListener('mouseout', (e) => this.toggleBasketPopupToggle(e, false));
        }
    }

    //Toggle headerbasket
    toggleBasketPopupToggle(e, hide) {
        let basketPopup = document.querySelector('[data-js="basket-popup"]');

        //basketPopup.style.top = '-4px';

        if (hide) {
            basketPopup.className += ' show';
        } else {
            $(basketPopup).removeClass('show');
        }
    }
}

export default Basket;